/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Central BBPS Complaint & Dispute Console Wrapper
 * PATH: src/routes/transactionPayin/index.js
 */

import React from "react";
import TransactionPayInList from "routes/payout/TransactionPayInList";

const TransactionPayin = () => {
  return (
    <div className="complaint-list-page-container">
      <TransactionPayInList />
    </div>
  );
};

export default TransactionPayin;